(function () {
    'use strict';

    realmCommerceApp.controller("ProductListController", ProductListController);

    /*@ngInject*/
    function ProductListController(apiService, errorsService, $compile, $rootScope, products, cartService, gtmEcommerceService) {
        var vm = this;
        vm.pagination = {
            busy: false,
            after: 0,
            group: 'all',
            end: false,
            limit: 6
        }
        vm.loadMore = loadMore;
        vm.addBooklistItems = addBooklistItems;
        activate();

        function activate() {
            vm.products = products;
        }

        function loadMore() {
            if (vm.pagination.busy) return;
            vm.pagination.busy = true;
            apiService.loadProducts(vm.pagination.limit, vm.pagination.after, vm.pagination.group, 'html')
                .then(function (html) {
                    if (html) {
                        $("#more").append($compile(html)($rootScope));
                        vm.pagination.after = vm.pagination.after + vm.pagination.limit;
//                       googleAdverts.populateAdverts();
                    } else {
                        vm.pagination.end = true;
                    }
                    vm.pagination.busy = false;
                })
                .catch(errorsService.errorCallback);
        }

        function addBooklistItems(booklistId) {
            cartService.addBooklistItems(booklistId).then((data) => {
                data.bookListProducts.forEach((product) => {
                    gtmEcommerceService.sendAddToCart(product, 'productDetails', 1);
                });
            });
        }
    }
})();


// WEBPACK FOOTER //
// ./static/js/app/products/productlist.controller.js